import * as React from 'react';

import pluralize from 'pluralize';
import Tippy from '@tippyjs/react';

import { labelFormatter } from '@components/ScreenerResults/ScreenerChart/helpers';

const LABEL_STYLE = { fontFamily: 'inherit', fontSize: '14px' };

export const CustomLabel: React.FC<React.PropsWithChildren<{ text?: any } & Record<string, any>>> = (props) => (
  <Tippy content={props.text}>
    <text {...props} className='focus:outline-none' style={LABEL_STYLE} dy='4'>
      {labelFormatter(props.text)}
    </text>
  </Tippy>
);

export const CustomPieLabel: React.FC<React.PropsWithChildren<{ text?: any } & Record<string, any>>> = (props) => {
  const { datum, text } = props;

  return (
    <Tippy content={datum.x}>
      <text {...props} className='focus:outline-none' dy='4'>
        {labelFormatter(text)}
      </text>
    </Tippy>
  );
};

export const Title = ({ children }) => <p className='text-lg font-bold text-gray-700'>{children}</p>;

interface SubtitleProps {
  total?: number;
  type: string;
}

export const Subtitle: React.FC<React.PropsWithChildren<SubtitleProps>> = ({ total, type }) => {
  const totalResponses = pluralize('responses', total, true);

  return (
    <p className='mb-6 text-sm text-gray-500'>
      {type} | {totalResponses}
    </p>
  );
};
